import "./Oryza.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { BsArrowRight, BsArrowLeft , BsDot} from "react-icons/bs";
import { useRef } from 'react';
import { DefaultPlayer as Video } from "react-html5video";
import "react-html5video/dist/styles.css";
import introVideo from "../videos/oryza.MOV";

export const Oryza=()=>{

  const oryzasliderRef = useRef(null);
   const oryzaslider02Ref = useRef(null);
   const oryzaslider03Ref = useRef(null);

const bannerRef = useRef(null);

      var banner_slider_settings = {
        className: "aboutus-banner-slider-component",
        dots: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 1500,
        slidesToShow: 2.7,
        slidesToScroll: 1,
        arrows: false,
      };

  var oryza_slider_settings = {
    className: "oryza-grid-slider-component",
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <OryzaNextArrow />,
    prevArrow: <OryzaPrevArrow />,
  };


var oryza_slider02_settings = {
  className: "oryza-slider02-component",
  dots: false,
  infinite: true,
  speed: 500,
  autoplay: false,
  autoplaySpeed: 1500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  nextArrow: <Oryza02NextArrow />,
  prevArrow: false,
};

 var oryza_slider03_settings = {
   className: "oryza-testimonial-slider-component",
   dots: false,
   infinite: true,
   speed: 500,
   autoplay: false,
   autoplaySpeed: 1500,
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: true,
   nextArrow: <Oryza03NextArrow />,
   prevArrow: <Oryza03PrevArrow />,
 };
   
  function OryzaNextArrow() {
    return (
      <BsArrowRight
        className="oryza_nextarrow"
        onClick={handleSlider_01_NextClick}
      />
    );
  }

function  OryzaPrevArrow() {
  return (
    <BsArrowLeft
      className="oryza_prevarrow"
      onClick={handleSlider_01_PrevClick}
    />
  );
}

 function Oryza02NextArrow() {
   return (
     <div onClick={handleSlider_02_NextClick} className="oryza02_nextarrow">
       Next
     </div>
   );
 }


 function Oryza03NextArrow() {
   return (
     <BsArrowRight
       className="oryza-slider03-nextarrow"
       onClick={handleSlider_03_NextClick}
     />
   );
 }

 function Oryza03PrevArrow() {
   return (
     <BsArrowLeft
       className="oryza-slider03-prevarrow"
       onClick={handleSlider_03_PrevClick}
     />
   );
 }

 const handleSlider_03_NextClick = () => {
   oryzaslider03Ref.current.slickNext();
 };

 const handleSlider_03_PrevClick = () => {
   oryzaslider03Ref.current.slickPrev();
 };

  const handleSlider_01_NextClick = () => {
    oryzasliderRef.current.slickNext();
  };

 const handleSlider_01_PrevClick = () => {
   oryzasliderRef.current.slickPrev();
 };

  const handleSlider_02_NextClick = () => {
    oryzaslider02Ref.current.slickNext();
  };



return (
  <div id="project-oryza-main-wrapper">
    <div id="oryza-banner-section-wrap">
      <div id="oryza-banner-section-media-wrap">
        <Video autoplay loop id="banner-video">
          <source src={introVideo} type="video/webm" />
        </Video>
      </div>
      <div id="oryza-banner-section-text-wrap">
        <div id="oryza-banner-section-text-01">Oryza Farms</div>
        <div id="oryza-banner-section-text-02">
          An ideal location to blend nature with residence
        </div>
      </div>

      <div id="oryza-banner-section-slider-wrap">
        <Slider ref={bannerRef} {...banner_slider_settings}>
          <div className="oryza-banner-section-slider-img-wrap">
            <img src="./Oryza-img/oryza01.jpg" alt="" />
          </div>

          <div className="oryza-banner-section-slider-img-wrap">
            <img src="./Oryza-img/oryza02.jpeg" alt="" />
          </div>

          <div className="oryza-banner-section-slider-img-wrap">
            <img src="./Oryza-img/oryza03.jpeg" alt="" />
          </div>
        </Slider>
      </div>
    </div>

    <div id="project-oryza-luxury-wilderness-section-wrap">
      <div id="project-oryza-luxury-wilderness-section-title">
        The perfect mix between luxury & wilderness
      </div>
      <div id="project-oryza-luxury-wilderness-section-content-para-01">
        Oryza Farmland is the ideal location to blend nature with a Residence.
        About 30-minute drive separates the community from Gachibowli and the
        city.
      </div>
      <div id="project-oryza-luxury-wilderness-section-content-para-02">
        The project manages to strike the perfect mix between luxury &
        wilderness thanks to the presence of a magnificent lake on the property
        and the profusion of fruit & vegetable bearing plants on each plot. Here
        at Oryza Farmland, we’re here to assist you in selecting the best plot.
      </div>
    </div>

    <div id="project-oryza-image-slider-section-main-wrap">
      <Slider ref={oryzasliderRef} {...oryza_slider_settings}>
        <div>
          <div className="project-oryza-image-slider-row-01-wrap">
            <div className="project-oryza-image-slider-row-01-image-wrap">
              <img
                src="./Oryza-img/oryza01.JPG"
                alt=""
                className="project-oryza-image-slider-row-01-image"
              />
            </div>
            <div className="project-oryza-image-slider-row-01-image-wrap">
              <img
                src="./Oryza-img/oryza02.jpeg"
                alt=""
                className="project-oryza-image-slider-row-01-image"
              />
            </div>
          </div>

          <div className="project-oryza-image-slider-row-02-wrap">
            <img
              src="./Oryza-img/oryza03.jpeg"
              alt=""
              className="project-oryza-image-slider-row-02-image"
            />
          </div>
        </div>

        <div>
          <div className="project-oryza-image-slider-row-01-wrap">
            <div className="project-oryza-image-slider-row-01-image-wrap">
              <img
                src="./Oryza-img/oryza01.JPG"
                alt=""
                className="project-oryza-image-slider-row-01-image"
              />
            </div>
            <div className="project-oryza-image-slider-row-01-image-wrap">
              <img
                src="./Oryza-img/oryza02.jpeg"
                alt=""
                className="project-oryza-image-slider-row-01-image"
              />
            </div>
          </div>

          <div className="project-oryza-image-slider-row-02-wrap">
            <img
              src="./Oryza-img/oryza03.jpeg"
              alt=""
              className="project-oryza-image-slider-row-02-image"
            />
          </div>
        </div>

        <div>
          <div className="project-oryza-image-slider-row-01-wrap">
            <div className="project-oryza-image-slider-row-01-image-wrap">
              <img
                src="./Oryza-img/oryza01.JPG"
                alt=""
                className="project-oryza-image-slider-row-01-image"
              />
            </div>
            <div className="project-oryza-image-slider-row-01-image-wrap">
              <img
                src="./Oryza-img/oryza02.jpeg"
                alt=""
                className="project-oryza-image-slider-row-01-image"
              />
            </div>
          </div>

          <div className="project-oryza-image-slider-row-02-wrap">
            <img
              src="./Oryza-img/oryza03.jpeg"
              alt=""
              className="project-oryza-image-slider-row-02-image"
            />
          </div>
        </div>
      </Slider>
    </div>

    <div id="project-oryza-why-oryza-section-wrap">
      <div id="project-oryza-why-oryza-section-headline">Why Oryza?</div>
      <div id="project-oryza-why-oryza-section-content-para01">
        A flawlessly created environment is beginning to emerge a little bit
        outside of the city’s metropolitan chaos. It is located amidst infinite
        lengths of lush open areas with a profusion of fruit- and
        vegetable-producing plants.
      </div>
      <div id="project-oryza-why-oryza-section-content-para02">
        Reasonably close to the city i.e., merely 30 minutes from Gachibowli
        surrounded by metropolitan luxuries yet still being in the middle of
        nature, located a short drive near the best workplaces, shopping
        centers, and schools, yet blissfully free of commotion and noise.
      </div>
      <div id="project-oryza-why-oryza-section-content-para03">
        Being a resident of these spotless Farmlands is something to be proud
        of. It conveys information about your taste, sophistication, and
        elegance. It conveys who you are. At Oryza Farmland, our goal is to
        locate the ideal site.
      </div>
    </div>

    <div id="project-oryza-amenities-section-wrap">
      <div id="project-oryza-amenities-section-headline">Amenities</div>
      <div id="project-oryza-amenities-section-grid-wrap">
        <div className="project-oryza-amenities-section-grid">
          <img
            src="./Oryza-img/amenities01.png"
            alt=""
            className="project-oryza-amenities-section-grid-icon"
          />
          <div className="project-oryza-amenities-section-grid-text">
            50 Acres Land
          </div>
        </div>

        <div className="project-oryza-amenities-section-grid">
          <img
            src="./Oryza-img/amenities02.png"
            alt=""
            className="project-oryza-amenities-section-grid-icon"
          />
          <div className="project-oryza-amenities-section-grid-text">
            Vast Recreational Zone
          </div>
        </div>

        <div className="project-oryza-amenities-section-grid">
          <img
            src="./Oryza-img/amenities03.png"
            alt=""
            className="project-oryza-amenities-section-grid-icon"
          />
          <div className="project-oryza-amenities-section-grid-text">
            Party Lawn Gazebo
          </div>
        </div>

        <div className="project-oryza-amenities-section-grid">
          <img
            src="./Oryza-img/amenities04.png"
            alt=""
            className="project-oryza-amenities-section-grid-icon"
          />
          <div className="project-oryza-amenities-section-grid-text">
            Party Lawn Gazebo
          </div>
        </div>

        <div className="project-oryza-amenities-section-grid">
          <img
            src="./Oryza-img/amenities05.png"
            alt=""
            className="project-oryza-amenities-section-grid-icon"
          />
          <div className="project-oryza-amenities-section-grid-text">
            Children Activity Area
          </div>
        </div>

        <div className="project-oryza-amenities-section-grid">
          <img
            src="./Oryza-img/amenities06.png"
            alt=""
            className="project-oryza-amenities-section-grid-icon"
          />
          <div className="project-oryza-amenities-section-grid-text">
            Modernly Designed Country House
          </div>
        </div>

        <div className="project-oryza-amenities-section-grid">
          <img
            src="./Oryza-img/amenities07.png"
            alt=""
            className="project-oryza-amenities-section-grid-icon"
          />
          <div className="project-oryza-amenities-section-grid-text">
            Sports Play Zone Area
          </div>
        </div>

        <div className="project-oryza-amenities-section-grid">
          <img
            src="./Oryza-img/amenities08.png"
            alt=""
            className="project-oryza-amenities-section-grid-icon"
          />
          <div className="project-oryza-amenities-section-grid-text">
            Swimming Pool
          </div>
        </div>

        <div className="project-oryza-amenities-section-grid">
          <img
            src="./Oryza-img/amenities09.png"
            alt=""
            className="project-oryza-amenities-section-grid-icon"
          />
          <div className="project-oryza-amenities-section-grid-text">
            100% Vastu
          </div>
        </div>

        <div className="project-oryza-amenities-section-grid">
          <img
            src="./Oryza-img/amenities10.png"
            alt=""
            className="project-oryza-amenities-section-grid-icon"
          />
          <div className="project-oryza-amenities-section-grid-text">
            24*7 Security & CCTV
          </div>
        </div>

        <div className="project-oryza-amenities-section-grid">
          <img
            src="./Oryza-img/amenities11.png"
            alt=""
            className="project-oryza-amenities-section-grid-icon"
          />
          <div className="project-oryza-amenities-section-grid-text">
            Plots with Fruit Bearing Plants
          </div>
        </div>

        <div className="project-oryza-amenities-section-grid">
          <img
            src="./Oryza-img/amenities12.png"
            alt=""
            className="project-oryza-amenities-section-grid-icon"
          />
          <div className="project-oryza-amenities-section-grid-text">
            Club House
          </div>
        </div>
      </div>
    </div>

    <div id="project-oryza-schedule-tour-section-wrap">
      <div id="project-oryza-schedule-tour-section-headline">
        Schedule your virtual tour.
      </div>
      <button id="project-oryza-schedule-tour-section-request-btn">
        REQUEST NOW
      </button>
    </div>

    <div id="project-oryza-farmlands-slider02-wrap">
      <Slider ref={oryzaslider02Ref} {...oryza_slider02_settings}>
        <div className="project-oryza-farmlands-slider02-slide">
          <div className="project-oryza-farmlands-slider02-image-wrap">
            <img
              src="./Oryza-img/slider02-img.png"
              alt=""
              className="project-oryza-farmlands-slider02-image"
            />
          </div>
          <div className="project-oryza-farmlands-slider02-details-wrap">
            <span>01</span> <span>Oryza Farmlands</span>
          </div>
        </div>

        <div className="project-oryza-farmlands-slider02-slide">
          <div className="project-oryza-farmlands-slider02-image-wrap">
            <img
              src="./Oryza-img/slider02-img.png"
              alt=""
              className="project-oryza-farmlands-slider02-image"
            />
          </div>
          <div className="project-oryza-farmlands-slider02-details-wrap">
            <span>02</span> <span>Oryza Farmlands</span>
          </div>
        </div>

        <div className="project-oryza-farmlands-slider02-slide">
          <div className="project-oryza-farmlands-slider02-image-wrap">
            <img
              src="./Oryza-img/slider02-img.png"
              alt=""
              className="project-oryza-farmlands-slider02-image"
            />
          </div>
          <div className="project-oryza-farmlands-slider02-details-wrap">
            <span>03</span> <span>Oryza Farmlands</span>
          </div>
        </div>
      </Slider>
    </div>

    <hr id="project-oryza-features-section-section-divider" />

    <div id="project-oryza-features-section-wrap">
      <div id="project-oryza-features-section-headline">Features</div>
      <ul id="project-oryza-features-section-list-ul">
        <li>1 Min to Mucherla X-Road</li>
        <li>3 Mins Srisailam Highway (NH-765)</li>
        <li>5 Mins to Kadthal</li>
        <li>10 Mins World’s Biggest Pharmacy</li>
        <li>15 Mins RRR (Amangal)</li>
        <li>20 Mins to ORR (Tukkuguda)</li>
        <li>25 Mins to RGI Airport</li>
        <li>30 Mins to Gachibowli</li>
      </ul>
    </div>

    <div id="oryza-page-email-section-container">
      <div id="oryza-page-email-section-main-wrap">
        <div id="oryza-page-email-section-sub-wrap">
          <div id="oryza-page-email-section-logo-title-wrap">
            <div id="oryza-page-email-section-logo-wrap">
              <img
                src="./logo01.png"
                alt="logo"
                id="oryza-page-email-section-logo"
              />
            </div>
            <div id="oryza-page-email-section-title">VIHARI PROJECTS</div>
          </div>
          <div id="oryza-page-email-section-text">
            Start a new investment with vihari projects{" "}
          </div>

          <div id="oryza-page-email-section-input-wrap">
            <input
              type="text"
              id="oryza-page-email-section-input-element"
              placeholder="Enter your email id"
            />
            <BsArrowRight id="oryza-page-email-section-input-enter-icon" />
          </div>
        </div>
      </div>
    </div>

    <div id="oryza-testimonial-section-wrap">
      <div id="oryza-testimonial-section-headline">
        Encouraging words from our customers
      </div>
      <Slider ref={oryzaslider03Ref} {...oryza_slider03_settings}>
        <div className="oryza-testimonial-slider-content-wrap">
          <div className="oryza-testimonial-slider-content">
            <div>
              <img
                src="./Home-img/vihari-logo.png"
                alt=""
                className="oryza-testimonial-slider-content-image01"
              />
            </div>
            <div>
              We recently bought property here. They are very professional.The
              documents are clean and legally verified. Services & quality are
              good. They are offering all the amenities{" "}
            </div>
            <div>
              <img
                src="./Home-img/vihari-logo.png"
                alt=""
                className="oryza-testimonial-slider-content-image02"
              />
            </div>
          </div>
          <div className="oryza-testimonial-slider-content-user-name">
            <BsDot className="oryza-testimonial-slider-content-user-name-dot-icon" />{" "}
            Mithila Nahata
          </div>
        </div>

        <div className="oryza-testimonial-slider-content-wrap">
          <div className="oryza-testimonial-slider-content">
            <div>
              <img
                src="./Home-img/vihari-logo.png"
                alt=""
                className="oryza-testimonial-slider-content-image01"
              />
            </div>
            <div>
              Good and awesome projects. Really it's connecting to both nature
              and luxury style living. In short eco friendly projects. And they
              are very much cooperative
            </div>
            <div>
              <img
                src="./Home-img/vihari-logo.png"
                alt=""
                className="oryza-testimonial-slider-content-image02"
              />
            </div>
          </div>
          <div className="oryza-testimonial-slider-content-user-name">
            <BsDot className="oryza-testimonial-slider-content-user-name-dot-icon" />{" "}
            Ansuman Tripathy
          </div>
        </div>

        <div className="oryza-testimonial-slider-content-wrap">
          <div className="oryza-testimonial-slider-content">
            <div>
              <img
                src="./Home-img/vihari-logo.png"
                alt=""
                className="oryza-testimonial-slider-content-image01"
              />
            </div>
            <div>
              We recently bought property here. They are very professional.The
              documents are clean and legally verified. Services & quality are
              good. They are offering all the amenities{" "}
            </div>
            <div>
              <img
                src="./Home-img/vihari-logo.png"
                alt=""
                className="oryza-testimonial-slider-content-image02"
              />
            </div>
          </div>
          <div className="oryza-testimonial-slider-content-user-name">
            <BsDot className="oryza-testimonial-slider-content-user-name-dot-icon" />{" "}
            Mithila Nahata
          </div>
        </div>
      </Slider>
    </div>
  </div>
);

}